import usePDPContext from './usePDPContext';
const usePdpId = () => {
  return usePDPContext()?.id ?? null;
};
export default usePdpId;